<template>
    <a :href="baseURL" class="inline-flex items-center gap-4">
        <AppImg :src="`${assetsPath}${logoSource}`" :alt="variant === 'principal' ? '+IFMG' : 'IFMG'" :class="[
            'block w-auto object-contain z-10',
            variant === 'principal' ? 'h-12 lg:h-16 min-w-12 lg:min-w-16' : 'h-14 min-w-14'
        ]" decoding="async" :loading="variant === 'principal' ? 'eager' : 'lazy'" />
    </a>
</template>

<script setup lang="ts">
const props = defineProps({
    variant: {
        type: String,
        default: 'principal', // Pode ser 'principal' ou 'secundaria'
        validator: (value: string) => ['principal', 'secundaria'].includes(value)
    }
})

const config = useRuntimeConfig()
const baseURL = config.app.baseURL
const assetsPath = config.public.assetsPath

const logoSource = computed(() => {
    return props.variant === 'principal' ? 'img/mais-ifmg-logo-vertical.png' : 'img/logo_ifmg.png'
})
</script>